import { DocumentType } from '../types/document-revision-status.types';

interface DocumentIdentity {
  type?: string;
}

interface Document {
  type?: string;
  documentIdentity?: DocumentIdentity | null;
}

interface Revision {
  document: Document;
}

export function getDocumentType(revision: Revision): DocumentType | null {
  const type = revision.document.documentIdentity?.type ?? revision.document.type;

  if (type === DocumentType.DOCUMENT) {
    return DocumentType.DOCUMENT;
  }

  if (type === DocumentType.REGISTRATION) {
    return DocumentType.REGISTRATION;
  }

  return null;
}

export function isDocument(revision: Revision): boolean {
  return getDocumentType(revision) === DocumentType.DOCUMENT;
}

export function isRegistration(revision: Revision): boolean {
  return getDocumentType(revision) === DocumentType.REGISTRATION;
}

